import loanFormModel from '../../components/loan_application/form_models/loanFormModel';
import { defaultBorrowerLegalName } from '../../components/loan_application/form_models/constants';
import { genericRequiredFieldError } from '../../constants';
import { LoanApplication, type PROJECT_TYPE } from '../../modules/loan';
import { ValidationSchema } from '../interfaces';
import { Validation } from '../Validation';

const {
  formField: {
    projectType,
    systemPowerSingleOrMultipleUsers,
    systemPowerCommunityOrPPALease,
    systemPowerSubscribersAmount,
  },
} = loanFormModel;

export class SubscribersAmountValidation implements ValidationSchema {
  public name: string = systemPowerSubscribersAmount.name;
  public label: string = systemPowerSubscribersAmount.getLabel(
    defaultBorrowerLegalName
  );
  public dependsOn: string[] = [
    projectType.name,
    systemPowerSingleOrMultipleUsers.name,
    systemPowerCommunityOrPPALease.name,
  ];
  public type = 'string';
  public required = {
    message: '',
    value: false,
  };
  public nullable = true;

  when(
    projectType: string,
    singleOrMultipleUsers: string,
    communityOrPPALease: string,
    schema
  ) {
    if (!projectType || !LoanApplication.isSolar(projectType as PROJECT_TYPE))
      return schema;
    if (
      singleOrMultipleUsers === 'Multiple Users' &&
      communityOrPPALease === 'Community Solar Arrangement'
    ) {
      return schema.required(genericRequiredFieldError);
    }
    return schema;
  }
}
export default new Validation(new SubscribersAmountValidation());
